import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import getKeyPaths from 'src/util/getKeyPaths';

/**
 * This component is to be placed in the form you wish to have input errors observed when MUI input components are used.
 * It will use a list of errors gathered from `getKeyPaths()` then focus the first element in the list.
 * It will handle cases where an input field is given, as well as a select field.
 */
const InputErorrObserver = () => {
  const formik = useFormikContext();

  useEffect(() => {
    const { errors, isSubmitting, isValid } = formik;
    const focusError = ({ errors, isValid, isSubmitting }) => {
      if (isSubmitting && !isValid && Object.keys(errors).length > 0 && document !== 'undefined') {
        const inputs = document.getElementsByName(getKeyPaths(errors)[0]);
        // Allows for selecting MUI Select
        if (inputs[0]?.['ariaHidden'] === 'true') {
          inputs[0]?.['previousSibling'].focus();
          return;
        } else {
          inputs[0]?.focus();
          return;
        }
      }
    };
    focusError({ errors, isSubmitting, isValid });
  }, [formik]);
  return null;
};

export default InputErorrObserver;
